export const isLocalStorageSupported = () => {
    try {
        return "localStorage" in window && window.localStorage !== null;
    }
    catch (e) {
        return false;
    }
};
const storageServiceFactory = (getKey) => ({
    getKey,
    get: (personId) => {
        if (!personId || !isLocalStorageSupported()) {
            return null;
        }
        const filterObject = window.localStorage.getItem(getKey(personId));
        return filterObject && JSON.parse(filterObject);
    },
    set: (personId, data) => {
        if (!isLocalStorageSupported()) {
            return false;
        }
        window.localStorage.setItem(getKey(personId), JSON.stringify(data));
        return true;
    },
});
export const StudentActivityFilterStorageService = storageServiceFactory((personId) => `stuActFilter-${personId}`);
export const StaffActivityFilterStorageService = storageServiceFactory((personId) => `staffActFilter-${personId}`);
export const AdvisorStudentsSelectedFilterStorageService = storageServiceFactory((personId) => `advStuSelFil-${personId}`);
export const DashboardAlertFiltersStorageService = storageServiceFactory((personId) => `dashAlertFilters-${personId}`);
export const StudentFilterUpdateFeedFiltersStorageService = storageServiceFactory((personId) => `stuFiltFeedFilt-${personId}`);
export const CurrentAppFilterStorageService = storageServiceFactory((personId) => `appName-${personId}`);
export const PopulationFolderOpenStorageService = storageServiceFactory((personId) => `pop-folder-open-${personId}`);
